import { createSlice } from '@reduxjs/toolkit';
import appapi from '../../api/apiClient';

//Initial State of appslice
const initialState = {
  countryList: [],
  traderList: [],
  fuelTypes: [],
  shiptypes: [],
  shipOwners: [],
  shipMangers: [],
  operators: [],
  charterers: [],
  verifiers: [],
  graphData: [],
  notifyCount:0,
  transactionData: []
};

const appSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setCountry(state, action) {
      state.countryList = action.payload;
    },
    setFuelTypes(state, action) {
      state.fuelTypes = action.payload;
    },
    setShipTypes(state, action) {
      state.shiptypes = action.payload;
    },
    setShipOwners(state, action) {
      state.shipOwners = action.payload;
    },
    setShipMangers(state, action) {
      state.shipMangers = action.payload;
    },
    setShipOperators(state, action) {
      state.operators = action.payload;
    },
    setShipCharterers(state, action) {
      state.charterers = action.payload;
    },
    setVerifiers(state, action) {
      state.verifiers = action.payload;
    },
    setGraphData(state, action) {
      state.graphData = action.payload;
    },
    setNotifyCount(state, action) {
        state.notifyCount = action.payload;
    },
    setTransactionData(state, action) {
      state.transactionData = action.payload;
    }
  },
});

export const initCountryList = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`common/country`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setCountry(data.response || []));
        }
      }
    }
  };
};

export const initFuelList = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/fuelTypes`, {
        pageNumber: 1,
        pageSize: 50,
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setFuelTypes(data.response));
        }
      }
    }
  };
};

export const initShipTypesList = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/shipTypes`, {
        pageNumber: 1,
        pageSize: 50,
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setShipTypes(data.response || []));
        }
      }
    }
  };
};

export const initShipOwners = () => {
  return async (dispatch, getState) => {
    const { userId, user } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/getUserForFleet/${user?.companyId}`, {
        type: 'ship owner',
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setShipOwners(data.response || []));
        }
      }
    }
  };
};

export const initShipManagers = () => {
  return async (dispatch, getState) => {
    const { userId, user } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/getUserForFleet/${user?.companyId}`, {
        type: 'ship manager',
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setShipMangers(data.response || []));
        }
      }
    }
  };
};

export const initShipOperators = () => {
  return async (dispatch, getState) => {
    const { userId, user } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/getUserForFleet/${user?.companyId}`, {
        type: 'operator',
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setShipOperators(data.response || []));
        }
      }
    }
  };
};

export const initShipCharterers = () => {
  return async (dispatch, getState) => {
    const { userId, user } = getState().auth;
    if (userId) {
      const response = await appapi.get(`fleet/getUserForFleet/${user?.companyId}`, {
        type: 'charterer',
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setShipCharterers(data.response || []));
        }
      }
    }
  };
};

export const initverifiers = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`verifier/allVerifiers`, {
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setVerifiers(data.response || []));
        }
      }
    }
  };
};
export const initGraphData = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`/common/euaGraph`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setGraphData(data.response || []));
        }
      }
    }
  };
};

export const initTransactionData = () => {
    return async (dispatch, getState) => {
      const { userId, user } = getState().auth;
      if (userId) {
        const response = await appapi.get(`fleet/transactionDetails/${user?.companyId}`);
        if (response.ok) {
          const data = response.data;
          if (data.status === '7400') {
            dispatch(setTransactionData(data.response || []));
          }
        }
      }
    };
  };

  export const initNotifyCount = () => {
    return async (dispatch, getState) => {
      const { userId, user } = getState().auth;
      if (userId) {
        const response = await appapi.get(`notification/getNotificationUnReadCount/${userId}`);
        if (response.ok) {
          const data = response.data;
          if (data.status === '7400') {
            dispatch(setNotifyCount(data.response || 0));
          }
          else {
            dispatch(setNotifyCount(0));
          }
        }
      }
    };
  };

export const { setCountry, setFuelTypes, setShipTypes, setShipOwners, setShipMangers, setShipCharterers, setShipOperators, setVerifiers, setGraphData, setNotifyCount, setTransactionData } = appSlice.actions;
export default appSlice.reducer;
